/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import {
  AcessosConsolidadosContainer,
  AcessosEstadosContainer,
  BackButton,
  Button,
  Container,
  ContainerBody,
  Content,
  ContentInfo,
  EstadoContainer,
  Porcentagem,
  RegiaoCard,
  RegiaoContainer,
  RegiaoInfo,
} from './styles';
import {
  RankingRegiao,
  useDashboard,
} from '../../context/context/DashboardContext';
import { useHeaderFilter } from '../../hooks/hooks/useHeaderFilter';
import { useLoading } from '../../hooks/hooks/useLoading';
import { TipoRelatorio } from '../../components/components/TipoRelatorio';
import { EstadoCardComponent } from '../../components/components/EstadoCard';
import { Header } from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { GiBrazil } from 'react-icons/gi';
import Footer from '../../components/Footer/Footer';
import { IoIosArrowBack } from 'react-icons/io';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/Loader/Loader';
import { useUser } from '../../hooks/useUser';

interface EstadoRank {
  uf: string;
  nome: string;
  quantidade: number;
  totalRegiao: number;
}

export function Informacao() {
  const navigate = useNavigate();
  const [isState, setIsState] = useState(false);
  const [text, setText] = useState('Região');
  const [color, setColor] = useState<'yellow' | 'green'>('yellow');
  const [estadosRank, setEstadosRank] = useState<EstadoRank[]>([]);

  const { ranking, rankingEstados } = useDashboard();
  const { currentCompany } = useUser();
  const { dataFim, dataInicio, filtrado, chamado } = useHeaderFilter();
  const { showLoader, hideLoader, loader } = useLoading();

  let estadosR = [] as EstadoRank[];

  useEffect(() => {
    showLoader();
    const account = localStorage.getItem('account');
    const appAcesso = localStorage.getItem('appAcesso');
    rankingEstados(
      dataInicio,
      dataFim,
      account === 'Principal'
        ? String(currentCompany.credor_infos.credor_crm)
        : String(currentCompany.credor_infos.conta_parcelamento),
      Number(appAcesso!),
    );
    hideLoader();
  }, [currentCompany]);

  useEffect(() => {
    ranking?.regiao?.map((regiao) => {
      regiao?.estados?.map((estado) => {
        return estadosR.push({
          uf: estado.uf,
          nome: estado.nome,
          quantidade: estado.quantidade,
          totalRegiao: regiao.total,
        });
      });
    });
    setEstadosRank(
      estadosR.sort((a, b) =>
        a.quantidade === b.quantidade
          ? 0
          : a.quantidade > b.quantidade
          ? -1
          : 1,
      ),
    );

    hideLoader();
  }, [ranking]);

  useEffect(() => {
    showLoader();
  }, [filtrado, chamado]);

  function mudarTipoRelatorio() {
    if (isState) {
      setIsState(!isState);
      setText('Região');
      setColor('yellow');
    } else {
      setIsState(true);
      setText('Estado');
      setColor('green');
    }
  }

  function getPorcentagemRegiao(regiao: RankingRegiao) {
    let total = 0;
    regiao.estados.map((estado) => {
      total += (estado.quantidade / regiao.total) * 100;
    });
    return total % 1 === 0 ? `${total}` : total.toFixed(2);
  }

  function getPorcentagem(valor: number, total: number, isEstado?: boolean) {
    if (isEstado) {
      const porcetagem = (valor / ranking.totalAcordos) * 100;
      return porcetagem % 1 === 0 ? `${porcetagem}` : porcetagem.toFixed(2);
    } else {
      const porcetagem = (valor / total) * 100;
      return porcetagem % 1 === 0 ? `${porcetagem}` : porcetagem.toFixed(2);
    }
  }

  return (
    <Container>
      <Sidebar />
      <ContainerBody>
        <Header
          icon={<GiBrazil color="#A6A6A6" size="32px" />}
          title="Dashboard Portal"
        />
        <Content>
          {loader && <Loader />}
          <ContentInfo>
            <BackButton onClick={() => navigate('/dashboard')}>
              <IoIosArrowBack size={26} /> Voltar
            </BackButton>
            <Button onClick={mudarTipoRelatorio}>
              <TipoRelatorio text={text} circleColor={color} />
            </Button>
          </ContentInfo>

          {isState ? (
            <>
              <AcessosEstadosContainer>
                <EstadoContainer>
                  {estadosRank?.map((estado, index) => {
                    return (
                      <>
                        <EstadoCardComponent
                          key={index}
                          ranking={index + 1}
                          estado={`${estado?.nome} (${estado?.uf})`}
                          porcentagem={
                            estado?.quantidade > 0
                              ? getPorcentagem(
                                  estado?.quantidade,
                                  estado.totalRegiao,
                                  true,
                                )
                              : '0'
                          }
                          quantidade={new Intl.NumberFormat('pt-BR').format(
                            estado?.quantidade,
                          )}
                          isEstado
                        />
                      </>
                    );
                  })}
                </EstadoContainer>
              </AcessosEstadosContainer>
            </>
          ) : (
            <>
              <AcessosConsolidadosContainer>
                {ranking?.regiao?.map((regiao) => {
                  return (
                    <>
                      <RegiaoContainer key={regiao.regiao}>
                        <RegiaoCard>
                          <RegiaoInfo>
                            <strong>{regiao?.regiao}</strong>
                            <p>
                              {new Intl.NumberFormat('pt-BR').format(
                                regiao?.total,
                              )}
                            </p>
                          </RegiaoInfo>
                          <Porcentagem>
                            <p>
                              {regiao.total > 0
                                ? getPorcentagemRegiao(regiao)
                                : '0'}
                              %
                            </p>
                          </Porcentagem>
                        </RegiaoCard>

                        {regiao.regiao !== 'Outros' &&
                          regiao?.estados?.map((rank, index) => {
                            return (
                              <>
                                <EstadoCardComponent
                                  key={rank?.uf}
                                  ranking={index + 1}
                                  estado={`${rank?.nome} (${rank?.uf})`}
                                  quantidade={new Intl.NumberFormat(
                                    'pt-BR',
                                  ).format(rank?.quantidade)}
                                  porcentagem={
                                    rank?.quantidade > 0
                                      ? getPorcentagem(
                                          rank?.quantidade,
                                          regiao.total,
                                        )
                                      : '0'
                                  }
                                />
                              </>
                            );
                          })}
                      </RegiaoContainer>
                    </>
                  );
                })}
              </AcessosConsolidadosContainer>
            </>
          )}
          <Footer />
        </Content>
      </ContainerBody>
    </Container>
  );
}
